import { wellKnownRoutes } from './wellknown';
import { createRouter, createWebHistory } from 'vue-router';
import TimeoutPage from '@/pages/TimeoutPage.vue';
import NotFoundPage from '@/pages/NotFoundPage.vue';
import ConfigPage from '@/pages/ConfigPage.vue';
import { kycSessionRoute } from '@/routes/kyc.session.route';
import { afterEachGuard } from './guards/afterEachGuard';
import { beforeResolveGuard } from './guards/beforeResolveGuard';
import { beforeEachGuard } from './guards/beforeEachGuard';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    kycSessionRoute,
    {
      path: '/',
      redirect: {
        name: wellKnownRoutes.NotFound,
      },
    },
    {
      path: '/timeout',
      name: wellKnownRoutes.Timeout,
      meta: {
        name: 'Timeout',
      },
      component: TimeoutPage,
    },
    {
      path: '/not-found',
      name: wellKnownRoutes.NotFound,
      meta: {
        name: 'Page Not Found',
      },
      component: NotFoundPage,
    },
    {
      path: '/config',
      name: wellKnownRoutes.Config,
      meta: {
        name: 'Development Config',
      },
      component: ConfigPage,
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: {
        name: wellKnownRoutes.NotFound,
      },
    },
  ],
});

router.afterEach(afterEachGuard);

router.beforeEach(beforeEachGuard);

router.beforeResolve(beforeResolveGuard);

router.onError(async () => {
  await router.push({
    name: wellKnownRoutes.Timeout,
  });
});
